import { StackView } from '~/screens/MyAgency/components/StackView';
import { mockCreatorData } from '~/screens/MyAgency/components/StackView/mocks/creatorMockEmptyTalentPage';

export const MockCreatorEmptyResults: React.FC = () => {
  return (
    <StackView
      agencyData={mockCreatorData}
      error={false}
      isInitialFetch={false}
      isFetchingNextPage={false}
      isLoading={false}
      isShared={false}
      withContent={true}
    />
  );
};
